<template>
  <div class="confirmation">
    <div class="icon text-center">
      <font-awesome-icon icon="fa-solid fa-check" />
    </div>
    <h2 class="text-center">Vielen Dank für deine Buchung</h2>
    <p class="text-center">Wir senden Dir alle Details per E-Mail.</p>
  </div>
</template>

<script>
export default {
    name: "Confirmation",
    mounted() {
      window.localStorage.removeItem('vuex'); 
    }
}
</script>

<style lang="scss" scoped>
.icon {
  color: $primary-color;
  font-size: 150px;
}
@media (min-width: 768px) {
  .confirmation {
    padding: 30px;
    border: 1px solid $border-color;
    margin-top: 54px;
    margin-bottom: 100px;
  }
}
</style>